import { useEffect, useState } from "react";
import Url from '../LocalService';
import { useFetchServices } from "../hooks/useFetchServices";

export const Actions = () => {
    let [dto, setDto] = useState([]);
    let [lookup, setLookup] = useState([]);
    let [filterdto, setFilterdto] = useState(undefined);
    //Length is for showing the Data Loading message.
    let [dtoLength, setDtoLength] = useState(null);
    let fechtservices = useFetchServices();

    const loadDto = () =>{
      /*
      fetch(Url + "tarefa.getall.php")
      .then((res) => {
        return res.json();
      })
      */
      fechtservices.executeService({method:"GET",endpoint:"tarefa.getall.php",body:{request:"getall"}})
      .then((data) => {
        if (data.success) {
            setDto(data.data.reverse());
            setDtoLength(true);
        } else {
            setDtoLength(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    };

    useEffect(() => {
      loadDto();
      }, []);


    useEffect(() => {
        /*
        fetch(Url + "usuario.lookup.php")
          .then((res) => {
            return res.json();
          })
        */
        fechtservices.executeService({method:"GET",endpoint:"usuario.lookup.php",body:{request:"lookup"}})
          .then((data) => {
            if (data.success) {
              setLookup(data.data);
            } 
          })
          .catch((err) => {
            console.log(err);
          });
      }, []);

    const getItemlookup = (theID) => {
      let found = lookup.filter((dt) => {
        return dt.idusuario === theID;
      });
      let nome = "";
      found.map((fnd) =>{
        nome = fnd.nome;
      });
      return nome;
    };

    const testDto = (tested) => {
      if (tested.pconcluido === undefined)
        tested ={
          ...tested,
          pconcluido: 0,
        };
      if (tested.nome === undefined) alert("Informe a tarefa!");
      if (tested.idresponsavel === undefined) alert("Informe o responsável!");
      if (tested.estimativa === undefined) alert("Informe a estimativa!");
      return tested;
    };

    const insertDto = (newDto) => {
        newDto = {...testDto(newDto),};
        /*
        fetch(Url + "tarefa.insert.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newDto),
        })
        .then((res) => {
            return res.json();
        })
        */
        fechtservices.executeService({method:"POST",endpoint:"tarefa.insert.php",body:newDto})
        .then((data) => {
            if (data) {
                setDto([
                {
                    idtarefa: data.idtarefa,
                    ...newDto,
                },
                    ...dto,
                ]);
                setDtoLength(true);
                loadDto();
            } else {
                alert(data.msg);
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };
    
  // Enabling the edit mode for a listed.
  const editMode = (idtarefa) => {
      dto = dto.map((dt) => {
      if (dt.idtarefa === idtarefa) {
        dt.isEditing = true;
        return dt;
      }
      dt.isEditing = false;
      return dt;
    });
    setDto(dto);
  };

  // Cance the edit mode.
  const cancelEdit = (idtarefa) => {
    dto = dto.map((dt) => {
      if (dt.idtarefa === idtarefa) {
        dt.isEditing = false;
        return dt;
      }
      return dt;
    });
    setDto(dto);
  };

  // Updating a dto.
  const updateDto = (dtoData) => {
    dtoData = {...testDto(dtoData),};
    /*
    fetch(Url + "tarefa.update.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dtoData),
    })
      .then((res) => {
        return res.json();
      })
      */
      fechtservices.executeService({method:"POST",endpoint:"tarefa.update.php",body:dtoData})
      .then((data) => {
        if (data.success) {
          dto = dto.map((dt) => {
            if (dt.idtarefa === dtoData.idtarefa) {
              dt.isEditing = false;
              dt.nome = dtoData.nome;
              dt.estimativa = dtoData.estimativa;
              dt.pconcluido = dtoData.pconcluido;
              dt.nota = dtoData.nota;
              dt.idresponsavel = dtoData.idresponsavel;
              dt.responsavel = getItemlookup(dtoData.idresponsavel);
              return dt;
            }
            return dt;
          });
          setDto(dto);
        } else {
          alert("Não foi possível atualizar os dados");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

    // Deleting.
  const deleteDto = (theID) => {
      // filter outing the.
    let dtoDeleted = dto.filter((dt) => {
      return dt.idtarefa !== theID;
    });
    /*
    fetch(Url + "tarefa.delete.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idtarefa: theID }),
    })
      .then((res) => {
        return res.json();
      })
      */
      fechtservices.executeService({method:"POST",endpoint:"tarefa.delete.php",body:{ idtarefa: theID }})
      .then((data) => {
        if (data.success) {
          setDto(dtoDeleted);
          if (dto.length === 1) {
            setDtoLength(0);
          }
        } else {
          alert(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return {
    dto,
    editMode,
    cancelEdit,
    updateDto,
    insertDto,
    deleteDto,
    dtoLength,
    lookup,
    getItemlookup,
    filterdto,
    setFilterdto,
  };

}